import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
import { transformFiltersToQuery, transformRateToPrice } from '../framework/utils/FiltersUtils';
class SearchAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        // ADV-259: trackingQuery carries the &pageType=...&module=...&requestPurpose=... classification
        // query params (see MessageSchemes.PageType/ModuleSurface/RequestPurpose) — optional so any
        // caller not yet updated keeps the pre-ADV-259 (untagged SRL) behavior server-side.
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters, offset = 0, limit = 10, sortQuery = '', trackingQuery = '') => {
                const query = transformFiltersToQuery(filters);
                const transformedQuery = transformRateToPrice(query);
                return this.privateRequest('get', `search/car/formatted?limit=${limit}&offset=${offset}${sortQuery}${trackingQuery}`, transformedQuery);
            }
        });
        Object.defineProperty(this, "getCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters, isAlreadyTransformed) => {
                const query = isAlreadyTransformed ? filters : transformFiltersToQuery(filters);
                const transformedQuery = transformRateToPrice(query);
                return this.request('post', 'count/car', transformedQuery);
            }
        });
        Object.defineProperty(this, "getCarViewsAggregationData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dateFrom, dateTo, aggMode) => {
                const query = { dateFrom, dateTo, aggMode };
                return this.privateRequest('get', 'aggregation/carImp', query);
            }
        });
        this.setConfig(config);
    }
}
export default new SearchAPI({
    baseURL: config.searchAPI.url
});
